import { ARTICLE_TYPES } from "@consts";

export default {
	name: "ArticleTeaser",
	props: {
		articleInfo: {
			type: Object,
			required: true,
		},
		layoutType: {
			type: String,
			required: false,
			default: "",
		},
	},
	computed: {
		articleImage() {
			const image = this.articleInfo.coverImage;

			if (this.layoutType !== ARTICLE_TYPES.LEAD && image.urlSmall) {
				return image.urlSmall;
			}

			if (
				this.layoutType === ARTICLE_TYPES.LEAD &&
				!this.isSmallDevice &&
				image.urlBase
			) {
				return image.urlBase;
			}

			if (image.urlMedium) {
				return image.urlMedium;
			}

			if (image.urlBase) {
				return image.urlBase;
			}

			return null;
		},
		articleLink() {
			const isWordleArticle =
				this.articleInfo.fullSlug.includes("wordle.word-lists");
			return isWordleArticle
				? `/wordle/word-lists/${this.articleInfo.fullSlug.substr(19)}/`
				: `/blog/${this.articleInfo.fullSlug.substr(5)}/`;
		},
		articleDate() {
			return new Date(this.articleInfo.publishedAt).toLocaleDateString(
				"en",
				{
					month: "short",
					day: "numeric",
					year: "numeric",
				}
			);
		},
		articleMeta() {
			let authorName = "";
			if (
				this.articleInfo.author.displayName &&
				this.layoutType === ARTICLE_TYPES.LEAD
			) {
				authorName = `${this.articleInfo.author.displayName} &bull; `;
			}
			let separator = " &bull; ";
			if (
				!this.isSmallDevice &&
				this.layoutType === ARTICLE_TYPES.REMAINING
			) {
				separator = "<br />";
			}

			return `${authorName}${this.articleDate}${separator}${this.readTime}`;
		},
		readTime() {
			return `${this.articleInfo.minutesToRead} ${this.$t(
				"ArticlesIndexPageReadingTime"
			)}`;
		},
	},
	data() {
		return {
			ARTICLE_TYPES,
		};
	},
};
